<template>
  <div id="water" style="width: 100%; height: 100%"></div>
</template>
<script>
import * as echarts from "echarts";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    var water = document.getElementById("water");
    var myEcharts = echarts.init(water);
    var option = {
      tooltip: {
        trigger: "axis",
      },
      grid: {
        left: "5%",
        right: "5%",
        bottom: "5%",
        containLabel: true,
      },
      legend: {
        data: ["水的消耗量", "喂水频率"],
        textStyle: {
          color: "white",
        },
      },
      calculable: true,
      xAxis: [
        {
          boundaryGap: false,
          type: "category",
          data: ["第一季度", "第二季度", "第三季度", "第四季度"],
          axisLabel: {
            color: "white",
          },
          axisTick: {
            show: true,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "white",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          axisLabel: {
            color: "white",
          },
          nameTextStyle: {
            color: "white",
          },
          splitLine: {
            show: true,
            lineStyle: {
              // 在 lineStyle 中设置线的样式
              color: "#02437c", // 将线的颜色设置为灰色
              opacity: 0.5,
            },
          },
        },
      ],
      series: [
        {
          name: "水的消耗量",
          type: "line",
          barWidth: "25%",
          smooth: true,
          data: [94.5, 87.6, 82.5, 89],
          areaStyle: {},
          tooltip: {
            valueFormatter: function (value) {
              return value + "吨";
            },
          },
          lineStyle: {
            // 设置线条的style等
            normal: {
              color: "#25b0f3", // 折线线条颜色:红色
            },
          },
          itemStyle: {
            // 设置线条上点的颜色（和图例的颜色）
            normal: {
              color: "#25b0f3",
            },
          },
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#25b0f3", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#25b0f35e", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        {
          name: "喂水频率",
          type: "line",
          barWidth: "25%",
          smooth: true,
          tooltip: {
            valueFormatter: function (value) {
              return value + "次";
            },
          },
          data: [115, 152, 130, 110],
          areaStyle: {},
          lineStyle: {
            // 设置线条的style等
            normal: {
              color: "#c2a91a", // 折线线条颜色:红色
            },
          },
          itemStyle: {
            // 设置线条上点的颜色（和图例的颜色）
            normal: {
              color: "#c2a91a",
            },
          },
          symbolSize: 8,
          itemStyle: {
            normal: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#c2a91a", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#c2a91a5e", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
      ],
    };
    myEcharts.setOption(option);
    window.addEventListener("resize", () => {
      myEcharts.resize();
    });
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
